import styled from '@emotion/styled';
import ErrorText from '../ErrorText';

const OutdatedBrowserMessage = styled(ErrorText)(({ theme }) => ({
  color: theme.palette.primary.main
}));

export default OutdatedBrowserMessage;
